import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { setAnalyticsConsent } from "@/utils/analytics";

const STORAGE_KEY = "analytics_consent";

const copy = {
  nl: {
    title: "Cookies",
    body: "Wij gebruiken analytische cookies om de website te verbeteren. Je kunt dit weigeren zonder gevolgen voor je bezoek.",
    accept: "Accepteren",
    decline: "Weigeren",
  },
  en: {
    title: "Cookies",
    body: "We use analytics cookies to improve this website. You can decline without any impact on your visit.",
    accept: "Accept",
    decline: "Decline",
  },
} as const;

const CookieConsent = () => {
  const { language } = useLanguage();
  const [visible, setVisible] = useState(false);
  const t = copy[language === "en" ? "en" : "nl"];

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  if (!visible) return null;

  const decide = (granted: boolean) => {
    setAnalyticsConsent(granted);
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label={t.title}
      className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-xl rounded-xl border border-border bg-card p-4 shadow-lg sm:left-6 sm:right-auto sm:mx-0"
    >
      <p className="text-sm text-muted-foreground">{t.body}</p>
      <div className="mt-3 flex gap-2">
        <Button size="sm" onClick={() => decide(true)}>
          {t.accept}
        </Button>
        <Button size="sm" variant="outline" onClick={() => decide(false)}>
          {t.decline}
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
